import { initInfoPopup } from "./initInfoPopup";

export const infoPopup = {
  initInfoPopup
};
